import React, { useState, useEffect } from 'react';

const Admin = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/subscribers`);
      const data = await response.json();
      setSubscribers(data.subscribers || []);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch subscribers:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'DM Sans, sans-serif' }}>
        <h2>Loading subscribers...</h2>
      </div>
    );
  }

  return (
    <div style={{ padding: '40px', fontFamily: 'DM Sans, sans-serif', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', marginBottom: '10px', color: '#2C1F14' }}>
        Newsletter Subscribers
      </h1>
      <p style={{ color: '#6B5744', marginBottom: '30px' }}>
        Total subscribers: <strong>{subscribers.length}</strong>
      </p>

      {subscribers.length === 0 ? (
        <p style={{ color: '#6B5744' }}>No subscribers yet.</p>
      ) : (
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse',
          background: '#F5F0E8',
          border: '0.5px solid #DDD4C0'
        }}>
          <thead>
            <tr style={{ background: '#EDE5D8', borderBottom: '0.5px solid #DDD4C0' }}>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '12px', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C4A882' }}>
                Email
              </th>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '12px', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C4A882' }}>
                Subscribed At
              </th>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '12px', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C4A882' }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {subscribers.map((subscriber, index) => (
              <tr key={index} style={{ borderBottom: '0.5px solid #DDD4C0' }}>
                <td style={{ padding: '16px', color: '#2C1F14' }}>{subscriber.email}</td>
                <td style={{ padding: '16px', color: '#6B5744' }}>
                  {new Date(subscriber.subscribed_at).toLocaleString()}
                </td>
                <td style={{ padding: '16px' }}>
                  <span style={{
                    background: subscriber.status === 'active' ? '#C4A882' : '#EDE5D8',
                    color: subscriber.status === 'active' ? '#2C1F14' : '#6B5744',
                    padding: '4px 12px',
                    fontSize: '11px',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase'
                  }}>
                    {subscriber.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div style={{ marginTop: '40px' }}>
        <a 
          href="/" 
          style={{
            display: 'inline-block',
            padding: '12px 24px',
            background: '#2C1F14',
            color: '#F5F0E8',
            textDecoration: 'none',
            fontSize: '11px',
            letterSpacing: '0.12em',
            textTransform: 'uppercase'
          }}
        >
          ← Back to Website
        </a>
      </div>
    </div>
  );
};

export default Admin;